
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/line-ads",
      function () {
        return require("private-next-pages/destinations/line-ads.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/line-ads"])
      });
    }
  